<template>
    <HeaderView />

    <div class="container-fluid">

        <BannerView v-if="showBanner" />

        <div class="container mt-5">

            <div class="row">
                <div class="mission-container">
                    <p class="caption">Contact</p>
                    <p>
                        Heeft u een vraag, een klacht of wilt u iets melden? LeefGoed staat voor u klaar.
                    </p>
                </div>
            </div>
        </div>

        <div class="header-image image-3"></div>

        <div class="container mt-5">
            <div class="row">
                <div class="news-container">
                    <h2>Klantenservice</h2>
                    <p>Voor vragen over uw huurovereenkomst, uw woning of onze diensten kunt u contact
                        opnemen met onze klantenservice. Wij zijn bereikbaar op werkdagen van 08:30 tot
                        17:00 uur.</p>
                    <p>
                        <strong>Telefoon:</strong> 055 – 123 45 6789<br />
                        <strong>E-mail:</strong>info@leefgoed.nl</p>

                    <h2>Bezoekadres</h2>
                    <p>LeefGoed<br />
                        Stationsplein 42<br />
                        7311 NE {{ CityName }}</p>

                    <h2>Reparaties en storingen</h2>
                    <p>Voor het melden van reparaties of storingen aan uw woning kunt u gebruikmaken
                        van het huurdersportaal Mijn LeefGoed, of telefonisch contact opnemen met
                        onze klantenservice. Bij spoedsituaties buiten kantooruren is onze storingsdienst
                        bereikbaar via <strong>055 – 123 45 6789</strong>.</p>

                    <h2>Huurdersorganisatie</h2>
                    <p>De huurdersorganisatie van LeefGoed behartigt de belangen van alle huurders.
                        Heeft u een vraag of wilt u betrokken raken bij het beleid van LeefGoed?
                        Neem contact op via <strong>huurders@leefgoed.nl</strong>.</p>
                </div>
            </div>
        </div>

        <!-- <div class="header-image image-4" style="margin-top:3rem;"></div> -->
    </div>

    <FooterView />
</template>

<script>
import HeaderView from '@/components/HeaderView.vue';
import BannerView from '@/components/BannerView.vue';
import FooterView from '@/components/FooterView.vue';
import constants from '@/constants.js';

export default {
    name: 'InfoBeveiliging',
    components: {
        HeaderView, BannerView, FooterView
    },
    data() {
        return {
            CityName: constants.CityName
        };
    },
};
</script>

<style scoped>
.container-fluid {
    margin-bottom: 3em;
}

.mission-container {
    box-sizing: border-box;
    max-width: 73.125rem;
    padding-bottom: 1.3125rem;
    background: white;
}

.fictional-client-mission {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 3.75rem;
}

.fictional-client-container {
    box-sizing: border-box;
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}

.journey-guide {
    box-sizing: border-box;
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding-bottom: 1.75rem;
    margin-left: 2.9375rem;
}

.fictional-client-text {
    box-sizing: border-box;
    flex: 0 1 auto;
    margin-left: 1.875rem;
}

.journey-guide1 {
    box-sizing: border-box;
    flex: 0 1 auto;
    margin-left: -1.1875rem;
}

.signature {
    font-size: 15pt;
    display: block;
    margin-top: 2rem;
}

.header-image {
    width: 100%;
    height: 11em;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.image-1 {
    background-image: url(@/assets/carousel_2.jpg);
}

.image-2 {
    background-image: url(@/assets/about-us.jpg);
}

.image-3 {
    background-image: url(@/assets/office-with-logo.jpg);
}

.image-4 {
    background-image: url(@/assets/about-us-3.jpg);
}

.news-container {
    background: #f6f9ff;
    padding: 2.5em;
}

.news-container p {
    text-align: justify;
}

.news-container h2 {
    color: #444;
    font-weight: normal;
    margin-bottom: 0.5em;
    font-size: 1.9rem;
}
</style>